// Detects Meta's in-app browsers (Facebook, Messenger, Instagram) and builds
// an escape hatch out of them.
//
// Most traffic arrives through the Facebook page, and tapping a link there
// opens this site inside Facebook's own webview, not the phone's browser.
// Everything works in there except the one thing that matters at checkout:
// Square's card iframe, which needs storage/cookie access the webview
// partitions away, so the card fields silently never come up. Nothing we load
// or retry fixes that from inside — the only real fix is getting the buyer
// into their actual browser.
//
// Android can do that programmatically: navigating to an intent:// URL asks
// the OS to reopen the current page in the default browser, and Facebook's
// webview honors it. iOS has no such door — the buyer has to use the app's own
// "Open in browser" menu item, so all we can do there is point at it.

export function detectInAppBrowser() {
  const ua = navigator.userAgent || '';

  // FBAN/FBAV/FB_IAB cover Facebook and Messenger on both platforms;
  // Instagram announces itself by name.
  const app =
    /FBAN|FBAV|FB_IAB|FBIOS/i.test(ua) ? 'Facebook'
      : /Instagram/i.test(ua) ? 'Instagram'
        : null;
  if (!app) return null;

  const os = /iPhone|iPad|iPod/i.test(ua) ? 'ios'
    : /Android/i.test(ua) ? 'android'
      : 'other';

  return { app, os, ua };
}

// The current page (query string and all, so ?phone= survives the hop) as an
// Android intent URL. Assigning location to this from inside the webview
// reopens the page in the phone's default browser.
export function androidExternalBrowserUrl() {
  const { host, pathname, search } = window.location;
  return `intent://${host}${pathname}${search}#Intent;scheme=https;action=android.intent.action.VIEW;end`;
}
